import { render, staticRenderFns } from "./StudentWetecHistory.vue?vue&type=template&id=930b70fe&scoped=true"
import script from "./StudentWetecHistory.vue?vue&type=script&lang=ts"
export * from "./StudentWetecHistory.vue?vue&type=script&lang=ts"
import style0 from "./StudentWetecHistory.vue?vue&type=style&index=0&id=930b70fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "930b70fe",
  null
  
)

export default component.exports